import {
    Box,
    Button,
    CloseButton,
    Dialog,
    Field,
    Flex,
    Grid,
    GridItem,
    Image,
    Input,
    InputGroup,
    Link,
    Stack,
    Text,
    VStack,
} from "@chakra-ui/react";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { toaster } from "@/components/ui/toaster";
import { usePostFormMutation } from "@/hooks/microservicesApi";

import ContactModal from "./contactModal";

const CardCita = ({
    urlBrochure,
    tipo,
    id,
    city,
    urlDev,
    hubspotForm,
    showBrouchure,
    getDevelopmentQuery,
    numeroAsesor,
    minPrice,
    propertyType,
    nameAsesor,
}) => {
    const router = useRouter();
    const [nombre, setNombre] = useState("");
    const [apellidos, setApellidos] = useState("");
    const [telefono, setTelefono] = useState("");
    const [email, setEmail] = useState("");
    const history = useRouter();

    const [isOpen, setIsOpen] = useState(false);
    const [isPhoneOpen, setIsPhoneOpen] = useState(false);

    const onOpen = () => setIsOpen(true);
    const onClose = () => setIsOpen(false);
    const onPhoneOpen = () => setIsPhoneOpen(true);
    const onPhoneClose = () => setIsPhoneOpen(false);

    const esGuiaRent =
        router.pathname.includes("guiarent") || router.query["city-id"].includes("guiarent");
    const guiarentHubspotFormDirecta = "664b54d0-13c5-416a-a56c-9fa8ec4f5bfb";
    const [postForm] = usePostFormMutation();

    const handleApartarComprar = () => {
        if (id === "slAEu7c" || id === "sC5WkNH" || id === "s0k4deR") {
            if (getDevelopmentQuery) {
                const types = Object.keys(getDevelopmentQuery[0]);
                window.open(
                    `/desarrollo/seleccion/sct/${types.includes("view_3D") ? "3d" : "2d"}/${getDevelopmentQuery[0]._id}`
                );
                return;
            }
        } else {
            //Si no es ninguno de los anteriores no tenemos inventario por mostrar entonces enviamos al home
            window.location.href = "/Sistema/Home";
        }
    };

    useEffect(() => {
        if (propertyType) {
            switch (propertyType) {
                case "APARTMENT": {
                    setType("Departamentos");
                    break;
                }
                case "HOUSE": {
                    setType("Casas");
                    break;
                }
                case "TERRAIN": {
                    setType("Terrenos");
                    break;
                }
                case "DUPLEX_HOUSE": {
                    setType("Casas Duplex");
                    break;
                }
                case "OFFICE": {
                    setType("Oficinas");
                    break;
                }
                case "CONSULTING_ROOM": {
                    setType("Consultorios");
                    break;
                }
                case "WAREHOUSE": {
                    setType("Bodegas");
                    break;
                }
                case "SHOP_SHOPPING_CENTER": {
                    setType("Locales comerciales");
                    break;
                }
                case "SHOP": {
                    setType("Locales");
                    break;
                }
                case "INDUSTRIAL_BUILDING": {
                    setType("Industriales");
                    break;
                }
                case "RANCH": {
                    setType("Ranchos");
                    break;
                }
                case "BUILDING": {
                    setType("Edificios");
                    break;
                }
                default: {
                    setType("");
                }
            }
        }
    }, [propertyType]);

    const handleSubmitPhone = (hbs_form) => {
        let data_send = {
            id: hbs_form,
            body: {
                fields: [
                    {
                        name: "firstname",
                        value: nombre,
                    },
                    {
                        name: "lastname",
                        value: apellidos,
                    },
                    {
                        name: "email",
                        value: email,
                    },
                    {
                        name: "phone",
                        value: telefono,
                    },
                ],
                context: {
                    ipAddress: "3.14.97.137",
                    pageUri: "www.grupoguia.mx",
                    pageName: "Grupo Guia | " + tipo + " " + id,
                },
            },
        };
        if (hbs_form == "28a489aa-fa3c-45ff-bcd2-f7bf9a8004c8") {
            data_send.body.fields.push({
                name: "wiggot",
                value: id,
            });
        }
        postForm(data_send)
            .then(() => {
                setNombre("");
                setApellidos("");
                setEmail("");
                setTelefono("");
                onPhoneClose();
                setShowPhone(true);
                toaster.create({
                    title: "¡Tus datos fueron enviados correctamente!",
                    type: "success",
                    placement: "bottom-right",
                    duration: 4000,
                    closable: true,
                });

                history.push(`/desarrollos/thankyoupage-contactar-telefono/${numeroAsesor}`);
            })
            .catch((error) => {
                console.error("Error: ", error);
            });
    };

    const [type, setType] = useState("");
    const [showPhone, setShowPhone] = useState(false);
    const [idx, setIdx] = useState(0);

    return (
        <>
            <VStack
                position="sticky"
                borderRadius="md"
                border="1px solid #D9D9D9"
                boxShadow="md"
                bg="white"
            >
                <Box py={6} px={8} w="full">
                    {minPrice !== "$0.00 MXN" ? (
                        <Stack alignItems="center">
                            <Text fontSize="sm" fontWeight="400">
                                {type
                                    ? type + " desde"
                                    : city === "retail"
                                      ? "Desde: "
                                      : "Precio total:"}
                            </Text>
                            <Text fontSize="xl" fontWeight="600">{`${minPrice}`}</Text>
                        </Stack>
                    ) : null}
                    {["sDCOSrC", "s0k4deR", "slAEu7c", "sC5WkNH"].includes(id) && (
                        <Stack alignItems="center" py={2}>
                            <Button
                                rounded="full"
                                w="100%"
                                fontWeight="500"
                                color="black"
                                borderColor="#FFCD00"
                                _hover={{
                                    bg: "#EDBE00",
                                }}
                                onClick={() => handleApartarComprar()}
                            >
                                Elegir {type.substr(0, type.length - 1).toLowerCase()}
                            </Button>
                        </Stack>
                    )}
                    <Grid
                        templateColumns={{
                            base: "repeat(1, 1fr)",
                            md: city !== "retail" ? "repeat(2, 1fr)" : "repeat(1, 1fr)",
                        }}
                        w="full"
                        gap={3}
                        py={3}
                    >
                        {city !== "retail" && (
                            <GridItem
                                colSpan={1}
                                display={numeroAsesor === "0000000000" ? "none" : "block"}
                            >
                                <Button
                                    rounded="full"
                                    w="100%"
                                    color="#000"
                                    bg="transparent"
                                    borderColor="#FFCD00"
                                    borderWidth={1}
                                    fontSize="xs"
                                    fontWeight="400"
                                    _hover={{
                                        bg: "#EDBE00",
                                    }}
                                    onClick={() => {
                                        setIdx(0);
                                        onOpen();
                                    }}
                                >
                                    <Image
                                        src="https://media.grupoguia.mx/assets/home-page/fichas/Cita/whatsapp.png"
                                        alt="simple icon"
                                        w="20px"
                                        mr={2}
                                    />
                                    Enviar whatsapp
                                </Button>
                            </GridItem>
                        )}
                        <GridItem colSpan={numeroAsesor === "0000000000" ? 2 : 1}>
                            <Button
                                rounded="full"
                                w="100%"
                                color="black"
                                bg="transparent"
                                borderColor="#FFCD00"
                                borderWidth={1}
                                fontSize="xs"
                                fontWeight="400"
                                _hover={{
                                    bg: "#EDBE00",
                                }}
                                onClick={() => {
                                    setIdx(1);
                                    onOpen();
                                }}
                            >
                                <Image
                                    src="https://media.grupoguia.mx/assets/home-page/fichas/Cita/calendario.webp"
                                    alt="simple icon"
                                    w="20px"
                                    mr={2}
                                />
                                Quiero que me contacten
                            </Button>
                        </GridItem>
                    </Grid>
                    {numeroAsesor || city === "retail" ? (
                        <Grid
                            templateColumns={{ base: "repeat(4, 1fr)", md: "repeat(4, 1fr)" }}
                            w="full"
                            gap={3}
                            py={3}
                            px={7}
                            display={numeroAsesor !== "0000000000" ? "grid" : "none"}
                        >
                            <GridItem colSpan={2}>
                                <Text display="flex" letterSpacing="1px" fontSize="lg">
                                    <Image
                                        src="https://media.grupoguia.mx/assets/home-page/fichas/Cita/llamada.png"
                                        alt="simple icon"
                                        w="25px"
                                        mr={2}
                                    />
                                    {showPhone
                                        ? city === "retail"
                                            ? "3334844484"
                                            : numeroAsesor
                                        : numeroAsesor || city === "retail"
                                          ? city === "retail"
                                              ? "333 ..."
                                              : numeroAsesor?.substr(0, 3) + "..."
                                          : null}
                                </Text>
                            </GridItem>
                            <GridItem colSpan={2} justifySelf="end">
                                <Link
                                    onClick={() => {
                                        city !== "retail" ? onPhoneOpen() : setShowPhone(true);
                                    }}
                                    color="brand.600"
                                    fontWeight={600}
                                    disabled={showPhone}
                                >
                                    {showPhone ? "" : "Ver teléfono"}
                                </Link>
                            </GridItem>
                        </Grid>
                    ) : null}
                </Box>
                <Dialog.Root
                    open={isPhoneOpen}
                    onOpenChange={() => onPhoneClose()}
                    preventScroll
                    placement="center"
                    size="sm"
                >
                    <Dialog.Backdrop />
                    <Dialog.Positioner>
                        <Dialog.Content>
                            <Dialog.CloseTrigger asChild>
                                <CloseButton />
                            </Dialog.CloseTrigger>
                            <Dialog.Body p={6}>
                                <Stack py={6} px={4} borderBottomWidth="1px">
                                    <Text fontWeight={700} fontSize="md" textAlign="left">
                                        {" "}
                                        ¡Completa tus datos y encuentra el lugar para ti!
                                    </Text>
                                    <Text fontWeight={400} fontSize="xs">
                                        Te mostramos el teléfono y enviamos un mensaje para que te
                                        contacte un asesor.
                                    </Text>
                                </Stack>
                                <form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        handleSubmitPhone(
                                            tipo === "Propiedad"
                                                ? "28a489aa-fa3c-45ff-bcd2-f7bf9a8004c8"
                                                : forms_hbs
                                                  ? forms_hbs.form_phone
                                                  : "0e97644f-7f36-4f69-9695-766b05d842f5"
                                        );
                                    }}
                                >
                                    <Field.Root pt={6}>
                                        <Input
                                            rounded="full"
                                            placeholder="Nombre/s:"
                                            marginBottom="10px"
                                            id="nombres"
                                            type="text"
                                            value={nombre}
                                            required
                                            onChange={(e) => {
                                                e.preventDefault();
                                                setNombre(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                e.preventDefault();
                                                setNombre(e.target.value);
                                            }}
                                            _placeholder={{
                                                color: "#3C3C3C",
                                                fontSize: "md",
                                            }}
                                            px={4}
                                        />
                                    </Field.Root>
                                    <Field.Root>
                                        <Input
                                            rounded="full"
                                            placeholder="Apellidos:"
                                            marginBottom="10px"
                                            value={apellidos}
                                            id="apellidos"
                                            type="text"
                                            required
                                            onChange={(e) => {
                                                e.preventDefault();
                                                setApellidos(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                e.preventDefault();
                                                setApellidos(e.target.value);
                                            }}
                                            _placeholder={{
                                                color: "#3C3C3C",
                                                fontSize: "md",
                                            }}
                                            px={4}
                                        />
                                    </Field.Root>
                                    <Field.Root>
                                        <Input
                                            rounded="full"
                                            placeholder="Correo:"
                                            marginBottom="10px"
                                            value={email}
                                            id="email"
                                            type="email"
                                            required
                                            onChange={(e) => {
                                                e.preventDefault();
                                                setEmail(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                e.preventDefault();
                                                setEmail(e.target.value);
                                            }}
                                            _placeholder={{
                                                color: "#3C3C3C",
                                                fontSize: "md",
                                            }}
                                            px={4}
                                        />
                                    </Field.Root>
                                    <Field.Root>
                                        <InputGroup
                                            marginBottom="20px"
                                            borderLeftRadius="full"
                                            overflow="hidden"
                                            startAddon={
                                                <Flex
                                                    gap={2}
                                                    p={2}
                                                    w="100%"
                                                    h="100%"
                                                    bg="#FFF"
                                                    align="center"
                                                    borderLeftRadius="full"
                                                >
                                                    <Box backgroundColor="#FFFFFF" rounded="full">
                                                        <Image
                                                            src="https://media.grupoguia.mx/assets/home-page/icons/mexico.svg"
                                                            width="16px"
                                                            height="16px"
                                                            alt="mexico"
                                                        />
                                                    </Box>
                                                    <Box
                                                        backgroundColor="#FFFFFF"
                                                        borderLeftColor="#FFFFFF"
                                                        borderRadius="0px"
                                                        padding="0px"
                                                        paddingRight="10px"
                                                        color="#000"
                                                    >
                                                        +52
                                                    </Box>
                                                </Flex>
                                            }
                                        >
                                            <Input
                                                borderRadius="24px"
                                                placeholder="Teléfono:"
                                                type="number"
                                                id="telefono"
                                                value={telefono}
                                                required
                                                onChange={(e) => {
                                                    e.preventDefault();
                                                    setTelefono(e.target.value);
                                                }}
                                                onBlur={(e) => {
                                                    e.preventDefault();
                                                    setTelefono(e.target.value);
                                                }}
                                                _placeholder={{
                                                    color: "#3C3C3C",
                                                    fontSize: "md",
                                                }}
                                                px={4}
                                                pattern="[0-9]{10}"
                                                minLength={10}
                                            />
                                        </InputGroup>
                                    </Field.Root>
                                    <Button
                                        rounded="full"
                                        w="100%"
                                        fontWeight="500"
                                        color="black"
                                        borderColor="#FFCD00"
                                        bg="#FFCD00"
                                        _hover={{
                                            bg: "#EDBE00",
                                        }}
                                        type="submit"
                                    >
                                        Enviar
                                    </Button>
                                    <VStack alignItems="center" mt="4">
                                        <Checkbox
                                            required
                                            size="sm"
                                            color="accent.500"
                                            colorPalette="blue"
                                        >
                                            He leído y acepto los{" "}
                                            <Link href="/terminosycondiciones">
                                                {" "}
                                                Términos y condiciones.
                                            </Link>
                                        </Checkbox>
                                    </VStack>
                                </form>
                            </Dialog.Body>
                        </Dialog.Content>
                    </Dialog.Positioner>
                </Dialog.Root>
                <Dialog.Root
                    open={isOpen}
                    onOpenChange={() => onClose()}
                    preventScroll
                    placement="center"
                    size="sm"
                >
                    <Dialog.Backdrop />
                    <Dialog.Positioner overflow="hidden">
                        <Dialog.Content p={0}>
                            <Dialog.CloseTrigger asChild>
                                <CloseButton />
                            </Dialog.CloseTrigger>
                            <Dialog.Body>
                                <ContactModal
                                    id={id}
                                    urlBrochure={urlBrochure}
                                    showBrouchure={showBrouchure}
                                    getDevelopmentQuery={getDevelopmentQuery}
                                    city={city}
                                    tipo={tipo}
                                    numeroAsesor={numeroAsesor}
                                    nameAsesor={nameAsesor}
                                    onClose={onClose}
                                    hubspotForm={
                                        idx === 1
                                            ? tipo === "Propiedad"
                                                ? esGuiaRent
                                                    ? guiarentHubspotFormDirecta
                                                    : city === "retail"
                                                      ? hubspotForm
                                                      : "11d898e2-b44c-42f4-9af0-8d3624f962e2"
                                                : forms_hbs
                                                  ? forms_hbs.form_contact
                                                  : "a1304c3e-dab9-489e-86ee-704edb061d4f"
                                            : tipo === "Propiedad"
                                              ? city === "retail"
                                                  ? hubspotForm
                                                  : "1a13be0c-4017-4b20-ad33-dd3c606b6e51"
                                              : forms_hbs
                                                ? forms_hbs.form_whatsApp
                                                : "0e97644f-7f36-4f69-9695-766b05d842f5"
                                    }
                                    urlDev={urlDev}
                                    idx={idx}
                                    setIdx={setIdx}
                                />
                            </Dialog.Body>
                        </Dialog.Content>
                    </Dialog.Positioner>
                </Dialog.Root>
            </VStack>
        </>
    );
};

export default CardCita;
